import React from 'react';

type Props = {
  label: string;              // e.g., "AAPL • close (lookback 14)"
  onClick?: () => void;
};

const SeriesPill: React.FC<Props> = ({ label, onClick }) => {
  return (
    <button
      type="button"
      className="text-sm text-ink bg-newsprint-dark px-2 py-1 rounded-sm hover:bg-newsprint border border-rule"
      onClick={(e) => {
        // don’t let this start a drag or bubble out of the dropzone click handlers
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
      onPointerDown={(e) => {
        // avoids dnd picking this up as a drag start
        e.stopPropagation();
      }}
    >
      {label}
    </button>
  );
};

export default SeriesPill;